// extracted by mini-css-extract-plugin
export default {"group":"UserGroup_group__OviAZ","icon":"UserGroup_icon__0BXpX"};